/* eslint-disable jsx-a11y/anchor-is-valid */
import { FooterContext } from "@contexts/FooterContext";
import React, { useContext } from "react";

const EssentialLinks = () => {
  const { essentialLinks } = useContext(FooterContext);

  const path = typeof window !== "undefined" ? window.location.pathname : "";

  const underlineClass = `relative no-underline	 w-max inline-block hover:after:content-[''] hover:after:inline-block hover:after:w-full hover:after:h-[1.5px] hover:after:bg-forest-900 hover:after:absolute hover:after:left-0 hover:after:bottom-[-2px]`;

  return (
    <div className="flex flex-wrap justify-end gap-x-6 md:justify-center md:gap-x-4 sm:gap-y-2">
      {essentialLinks?.map((item, key) => {
        const link =
          item?.otherLink?.page?.value?.data?.url || item?.otherLink?.url;

        if (item?.linkType === "Cookie preferences") {
          return (
            <div className="flex" key={key}>
              <a
                key={key}
                href="#"
                onClick={e => {
                  e.preventDefault();
                  if (typeof window !== "undefined") {
                    window.DG_BANNER_API.showConsentBanner();
                    window.history.replaceState(null, "", path);
                  }
                }}
                className={`body--text-small ${underlineClass}`}
              >
                Cookie Preferences
              </a>
            </div>
          );
        }

        if (item?.linkType === "Do Not Share My Personal Information") {
          return (
            <div className="flex" key={key}>
              <a
                href="#"
                onClick={e => {
                  e.preventDefault();

                  if (typeof window !== "undefined") {
                    window.location.href = `https://preferences.simplepractice.com/form/opt_out`;
                  }
                }}
                className={`body--text-small sm:w-full text-center ${underlineClass}`}
              >
                Do Not Share My Personal Information
              </a>
            </div>
          );
        }

        return (
          <div className="flex" key={key}>
            <a
              href={link}
              target={
                item?.otherLink?.url
                  ? item.otherLink.url.includes("http")
                    ? "_blank"
                    : undefined
                  : undefined
              }
              className={`body--text-small ${underlineClass}`}
            >
              {item?.otherLink?.copy}
            </a>
          </div>
        );
      })}
    </div>
  );
};

export default EssentialLinks;
